/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Filter_All_AreasInputs */

const vi_care_log_filter_all_areas = /** @type {(inputs: Care_Log_Filter_All_AreasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả vùng trồng`)
};

/**

* @param {Care_Log_Filter_All_AreasInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_filter_all_areas = /** @type {((inputs?: Care_Log_Filter_All_AreasInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Filter_All_AreasInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_filter_all_areas(inputs)
});